module.exports = __webpack_public_path__ + "static/img/img_cabinet.db2072db.png";